import { RegisterContent } from './RegisterContent';

export default function RegisterPage() {
    return <RegisterContent />;
}
